import {
  CheckoutViewComponent,
  DraftEditorViewComponent,
  HomeViewComponent,
  NewCardViewComponent,
  OrderPaymentViewComponent,
  OrderReviewViewComponent,
  OrderSlipViewComponent,
  ReviewCardsViewComponent,
  SettingsViewComponent,
} from '@aa/angular/customer';
import {
  ForgotPasswordViewComponent,
  LoginViewComponent,
  PrivacyPolicyViewComponent,
  RegisterViewComponent,
  ResetPasswordViewComponent,
  ScheduleMeetingViewComponent,
  TermsOfServiceViewComponent,
} from '@aa/angular/core';
import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'register',
    component: RegisterViewComponent,
  },
  {
    path: 'login',
    component: LoginViewComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordViewComponent,
  },
  {
    path: 'reset-password/:userId/:token',
    component: ResetPasswordViewComponent,
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceViewComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyViewComponent,
  },
  {
    path: 'settings',
    component: SettingsViewComponent,
  },
  {
    path: '',
    component: HomeViewComponent,
  },
  {
    path: 'draft-editor',
    component: DraftEditorViewComponent,
  },
  {
    path: 'draft-editor/:draftId',
    component: DraftEditorViewComponent,
  },
  {
    path: 'draft-editor/:draftId/new-card',
    component: NewCardViewComponent,
  },
  {
    path: 'draft-editor/:draftId/cards/:cardId',
    component: NewCardViewComponent,
  },
  {
    path: 'draft-editor/:orderId/review-cards',
    component: ReviewCardsViewComponent,
  },
  {
    path: 'draft-editor/:draftId/checkout',
    component: CheckoutViewComponent,
  },
  {
    path: 'order/:orderId/payment',
    component: OrderPaymentViewComponent,
  },
  {
    path: 'order-review/:orderId',
    component: OrderReviewViewComponent,
  },
  {
    path: 'order-slip/:orderId',
    component: OrderSlipViewComponent,
  },
  {
    path: 'schedule-meeting',
    component: ScheduleMeetingViewComponent,
  },
];
